import React from 'react'
import { observer, inject } from 'mobx-react'
import { observable } from 'mobx'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import moment from 'moment'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'

const alertInfo = (store) => (<div className='col-xs-12'>
  <p className='alert alert-info'>
    <strong>{store.__('Info: ')} </strong>
    {store.__('Filter items that should be affected, otherwise leave inputs below blank.')}
  </p>
</div>)

const countriesSelect = (store, record, errors) => (<div className='col-xs-12'>
  <RegionsInput label={store.__('regions')} attr={'region_selected'}
    record={record} onChange={(key, val) => record.set(key, val)} errors={errors}
    optionsrecord={store.options} optionsattr={'Countries'} />
</div>)

// batch for pricings
const SetPricingsInactive = observer(({ store, record, type, errors }) => {
  if (type.get('setinactive_type_selected') !== 'pricings') {
    return null
  }

  return (
    <React.Fragment>
      {alertInfo(store)}
      <div className='col-xs-12 col-sm-8 col-md-4'>
        <SelectInput label={store.__('FlyPrivate Platform')} attr={'pricing_select_platform'} record={record}
          onChange={(key, val) => record.set(key, val)} optionsrecord={store.options}
          optionsattr={'FlyPrivatePlatforms'}
          labelattr='text' valueattr='value' />
      </div>
      <div className='col-xs-12 col-sm-8 col-md-4'>
        <SelectInput label={store.__('Sale Type')} attr={'pricing_select_type'} record={record}
          onChange={(key, val) => record.set(key, val)} optionsrecord={store.options}
          optionsattr={'VodSaleTypes'}
          labelattr='text' valueattr='value' />
      </div>
      <div className='col-xs-12 col-sm-8 col-md-4'>
        <SelectInput label={store.__('Pricing Tier')} attr={'pricing_select_tier'} record={record}
          onChange={(key, val) => record.set(key, val)} optionsrecord={store.options}
          optionsattr={'PricingTiers'}
          labelattr='text' valueattr='value' />
      </div>
      {countriesSelect(store, record, errors)}
    </React.Fragment>
  )
})

// batch for categories
const SetCategoryInactive = observer(({ store, record, type, errors }) => {
  if (type.get('setinactive_type_selected') !== 'categories') {
    return null
  }
  const catPlatform = store.getCatPlatform(store, null, 'category_selected')
  const catPlatformFilter = store.getCatPlatformFilter(catPlatform)
  record.set('platform_selected', catPlatform)

  return (
    <React.Fragment>
      {alertInfo(store)}
      <div className='col-xs-12'>
        <OptionSelect
          attr='platformFilter' label={store.__('platform')} value={catPlatform}
          onChange={store.updateStorageField(store, null, 'category_selected')}
          options={store.options.get('FlyPrivatePlatforms')} errors={errors}
          labelattr='text' />
      </div>
      <div className='col-xs-12 col-sm-8 col-md-6'>
        <SelectInput
          attr='category_selected' label={store.__('category')} record={record}
          onChange={(key, val) => record.set(key, val)} optionsrecord={store.options}
          optionsattr='FlyprivateCategories' valueFilterFc={catPlatformFilter}
          labelattr='text' valueattr='value' />
      </div>
      {countriesSelect(store, record, errors)}
    </React.Fragment>
  )
})

const InactiveDate = observer(({ store, record, newValid }) => {
  const validToMinDate = () => record.has('setinactive_type_selected') && record.get('setinactive_type_selected') === 'categories'
    ? (store.timeRestriction ? store.timeRestriction.flyprivateCategories.valid_to.minDate : moment())
    : (store.timeRestriction ? store.timeRestriction.flyprivate_video_pricing.valid_to.minDate : moment())

  const validDate = () => {
    const newDate = record.has('new_valid_to') && record.get('new_valid_to') && moment(record.get('new_valid_to')).isValid() &&
      moment(record.get('new_valid_to')).isSameOrAfter(validToMinDate(record), 'day')
      ? record.get('new_valid_to')
      : validToMinDate(record).format(defaultConst.DATE_FORMAT)
    record.set('new_valid_to', newDate)
    return newDate
  }

  return (
    <div className='col-xs-12 col-sm-4'>
      <DateInput
        attr={'new_valid_to'}
        attrValue={validDate()}
        errors={store.cv.errors}
        errorsValidation={true}
        label={store.__('Set new "Valid to" date')}
        minDate={validToMinDate()}
        onChange={(key, val) => record.set(key, val)}
        record={record}
      />
    </div>
  )
})

// NOT MODAL
export const SetAsInactiveNotModal = inject('store')(observer(({ store, disabledEntityFromBatch }) => {
  const record = store.cv.record
  const types = observable.map({
    setinactive_types_select: [
      { label: 'Pricings', value: 'pricings' },
      { label: 'Categories', value: 'categories' }
    ]
  })

  return (
    <div className='row'>
      <div className='col-xs-12'>
        <div className='row'>
          <div className='col-xs-12 col-sm-4'>
            <SelectInput attr={'setinactive_type_selected'} label={store.__('Select type')}
              optionsattr={'setinactive_types_select'} record={record} disabled={!!disabledEntityFromBatch}
              onChange={(key, val) => record.set(key, val)} optionsrecord={types} />
          </div>
        </div>
        {!disabledEntityFromBatch &&
            <React.Fragment>
              <div className='row'>
                <InactiveDate store={store} record={record} newValid={record.has('new_valid_to') && record.get('new_valid_to')} />
              </div>
              <div className='row'>
                <SetPricingsInactive store={store} type={record} record={record} />
              </div>
              <div className='row'>
                <SetCategoryInactive store={store} type={record} record={record} />
              </div>
            </React.Fragment>
        }
        <div >
          {record.get('setinactive_type_selected') === 'pricings' &&
          (!record.has('pricing_select_platform') || !record.get('pricing_select_platform')) &&
          <p className='alert alert-warning'>
            <strong>{store.__('Warning: ')} </strong>
            {store.__('No "Platform" is selected.')}
          </p>}
          <p className='alert alert-warning'>
            <strong>{store.__('Warning: ')} </strong>
            {store.__('This module does not change historical data with "Valid to" date in the past.')}
          </p>
          {record.has('region_selected') && record.get('region_selected') && record.get('region_selected').indexOf('WW') >= 0 &&
          <p className='alert alert-warning'>
            <strong>{store.__('Warning: ')} </strong>
            {store.__('World wide region "WW" is compared only against "WW" region.')}
          </p>}
        </div>
      </div>
    </div>
  )
}))

SetAsInactiveNotModal.propTypes = {
  store: PropTypes.object.isRequired
}

// MODAL
const SetInactiveDate = ({ store }) => {
  const handleAction = (action) => {
    store.toggleRightsCopyModal()
    store.batchSave(action)
  }
  const validToMinDate = linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING].subentity
    ? (store.timeRestriction ? store.timeRestriction.flyprivate_video_pricing.valid_to.minDate : moment())
    : (store.timeRestriction ? store.timeRestriction.flyprivateCategories.valid_to.minDate : moment())

  return !store.rightsCopyModal ? null : (
    <Modal show backdrop='static' onHide={() => store.toggleRightsCopyModal()} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{store.__('On which date to set as inactive')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ lineHeight: '2.7em', textAlign: 'left' }}>
        <div className='row'>
          <div className='col-xs-12 col-sm-8 col-md-4'>
            <DateInput
              attr={'new_valid_to'}
              attrValue={(store.cv.record.has('new_valid_to') && store.cv.record.get('new_valid_to')) || validToMinDate}
              label={store.__('Set new "valid to" date')}
              minDate={validToMinDate}
              onChange={(key, val) => store.cv.record.set(key, val)}
              record={store.cv.record}
            />
            <p className='alert alert-warning' style={{ lineHeight: '1em' }}>
              {store.__('This module does not change historical data with "Valid to" date in the past.')}
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <Button bsStyle='primary' onClick={() => handleAction('setAsInactive')}>
            {store.__('Submit')}
          </Button>
          <Button bsStyle='default' onClick={() => store.toggleRightsCopyModal()}>
            {store.__('Close')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

SetInactiveDate.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(SetInactiveDate))
